import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class BestGluteExercises extends Component {
  state = {
    menuToggled: false,
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>Les meilleurs exercices pour vos fessiers</title>
          <meta
            name="description"
            content="Vous ne pouvez pas toujours ajuster la forme de vos fessiers, mais avec les
              bons entraînements, vous pouvez les rendre plus fermes et plus forts."
          />
          <meta
            property="og:url"
            content="https://www.boxfit-fitness.com/best-glute-exercises"
          />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="Vous ne pouvez pas toujours ajuster la forme de vos fessiers, mais avec les
              bons entraînements, vous pouvez les rendre plus fermes et plus forts."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://cdn.fitzet.com/static%2Fbuttdowndoglegcirclesleft.jpg?alt=media"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          {/*this.state.menuToggled ? <MenuFunc off={this.setmenuoff} /> : null*/}
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div className="Screen">
          <div style={{ padding: "55px 20px 20px 20px" }}>
            <h2>Les meilleurs exercices pour fessiers</h2>
            <div style={{ display: "flex" }}>
              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fbuttdowndoglegcirclesleft.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Glute Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fbuttextendedlegbridgeleft.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Glute Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fbuttfirehydrantkickleft.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Glute Exercises"
                />
              </div>
            </div>
            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Le but est d'utiliser des exercices et techniques qui ciblent vos fessiers si vous  voulez avoir un <strong>arrière-train fort</strong>.
              Trois muscles distincts sont en fait les "fessiers" : les gluteus
              maximus (le muscle principal), les gluteus medius et les gluteus
              minimus.
            </p>

            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Vous ne pouvez pas toujours ajuster la forme de vos <strong>fessiers</strong>,
              Mais avec des exercices appropriés, vous pouvez les rendre plus fermes et plus
              forts. Avec divers exercices et entraînements cardio, le secret est de
              travailler tous les muscles sous différents angles.
            </p>

            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Ici <strong>BoxFit</strong>, nous avons trié sur le volet pour vous, les meilleurs   exercices pour fessiers. Cliquez ci-dessous pour commencer votre session de fessiers. 
            </p>

            <p style={{ fontSize: "18px", marginTop: "20px" }}>
              <button
                style={{
                  fontSize: "18px",
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                }}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/start-workout/butt",
                  });
                }}
              >
                Commencer l'entraînement{" "}
                <span role="img" aria-label="like">
                  🔥
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(BestGluteExercises);
